'use strict';

var ServiceTypes = require('./ServiceTypes'),
    keyMirror = require('react/lib/keyMirror'),
    invariant = require('react/lib/invariant');

var ShareTypes = keyMirror({
  FACEBOOK: null,
  TWITTER: null,
  GOOGLE: null,
  TUMBLR: null,
  PINTEREST: null
});

if ('production' !== process.env.NODE_ENV) {
  for (var key in ShareTypes) {
    if (ShareTypes.hasOwnProperty(key)) {
      invariant(
        ServiceTypes.hasOwnProperty(key),
        '%s is specified in ShareTypes but not in ServiceTypes',
        key
      );
    }
  }
}

module.exports = ShareTypes;


/** WEBPACK FOOTER **
 ** ./constants/ShareTypes.js
 **/